export function nameToAvatar(name: string) {
  const trimmed = name.trim();
  if (trimmed.length === 0) {
    return '';
  }

  const parts = trimmed.split(' ');

  const first = parts[0]?.[0];
  if (parts.length === 1) {
    return first.toUpperCase();
  }

  const last = parts[parts.length - 1]?.[0];

  return (first + last).toUpperCase();
}
